export default "__VITE_ASSET__ATTA4f3___"